<template>
  <div class="cell-wrap no-px2rem" @click="clickCoupon" :style="`margin-top: ${index > 0 ? '-13px' : '-3px'}`">
    <div class="new-user-coupon-tip" v-if="coupon.new_user" :class="newUserBgImg">
      <!-- <div class="new-user-coupon-tip-text font-regular">{{gettext('首单专享')}}</div> -->
    </div>
    <div class="cell-base">
      <div class="cell-info" :style="{'width': coupon.new_user ? '80%' : '100%'}">
        <div v-if="coupon.rl_custom_logo" class="shop-logo">
          <img :src="coupon.rl_custom_logo" alt="">
        </div>
        <div class="info">
          <div class="name font-demi">
            {{coupon.activity_name}}
          </div>
          <div class="desc font-regular" :style="{color: descColor}">
            {{couponDateDesc}}
          </div>
        </div>
      </div>
    </div>
    <div class="cell-extra">
      <div>
        <div v-if="coupon.coupon_type == couponType.DISCOUNT" class="cell-curreny">
          <div class="discount font-regular">
            {{coupon.discountStr}}
          </div>
          <div class="discount-type font-regular">%</div>
          <div class="discount-type font-regular">
            {{gettext('折')}}
          </div>
        </div>
        <div v-else class="cell-curreny" v-html="amountTmpl"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { sprintf, getLocale } from '@didi/gettext'
import { getAmountTmpl, getIntNumFromAmount } from '@/common/js/utils'

const couponType = {
  DISCOUNT: 100,
  AMOUNT: 3
}
export default {
  props: {
    coupon: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    },
    couponLength: {
      type: Number,
      default: 0
    },
    hasDesc: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      couponType,
      descColor: '#333'
    }
  },
  computed: {
    // 有效期描述
    couponDateDesc () {
      // 计算券有效期剩余天数
      const timeGap = (this.coupon.expire_millis - new Date().getTime()) / 1000 / 3600 / 24
      // 根据有效天数展示不同文案
      if (timeGap >= 3) {
        return this.gettext('有效时间:') + ' ' + this.coupon.expire_str_display
      } else if (timeGap < 3 && timeGap >= 1) {
        this.descColor = '#339A60'
        return sprintf(this.gettext('%s日内有效'), Math.ceil(timeGap))
      } else {
        this.descColor = '#339A60'
        return this.gettext('当日有效')
      }
    },
    newUserBgImg () {
      const locale = getLocale()
      let bgCls
      switch (locale) {
        case 'zh-CN':
          bgCls = 'new-user-bg-zh'
          break
        case 'es-MX':
          bgCls = 'new-user-bg-es'
          break
        case 'en-US':
          bgCls = 'new-user-bg-en'
          break
        case 'pt-BR':
          bgCls = 'new-user-bg-pt'
          break
        default:
          bgCls = 'new-user-bg-es'
      }
      return bgCls
    },
    // 货币template
    amountTmpl () {
      if (this.coupon.coupon_amount_split) {
        const split = {
          // TODO: 统一处理split
          ...this.coupon.coupon_amount_split,
          number: getIntNumFromAmount(this.coupon.coupon_amount_split.number)
        }
        const splitData = {
          split,
          symbolClass: 'amount-type font-regular',
          numberClass: 'amount font-regular'
        }
        return getAmountTmpl(splitData)
      } else {
        return ''
      }
    }
  },
  methods: {
    clickCoupon () {
      this.$emit('click')
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "~@/assets/styles/main.scss";
  @import "~@/assets/styles/var";

  .cell-wrap.no-px2rem {
    margin-top: -13px;
    padding: 22px 23px 20px 23px;
    display: flex;
    flex-direction: column;
    background-size: 100% 100%;
    background-image: url('~@/assets/images/banner/coupon_desc@2x.png');
    position: relative;
    .new-user-coupon-tip {
      position:absolute;
      top: 6px;
      right: 21px;
      width: 48.5px;
      height: 42.5px;
      padding: 5px 1px 10px 8px;
      box-sizing: border-box;
      text-align: center;
      background-size: 100% 100%;
      &-text {
        color: #FFF;
        font-size: 12px;
        -webkit-transform-origin-x: 0;
        -webkit-transform: scale(0.75);
      }
    }
    .new-user-bg {
      &-zh{ background-image: url('~@/assets/images/banner/new_user_coupon@2x_zh.png'); }
      &-en{ background-image: url('~@/assets/images/banner/new_user_coupon@2x_en.png'); }
      &-es{ background-image: url('~@/assets/images/banner/new_user_coupon@2x_es.png'); }
      &-pt{ background-image: url('~@/assets/images/banner/new_user_coupon@2x_pt.png'); }
    }
    .cell-base {
      display: flex;
      .cell-info {
        display: flex;
        width: 100%;
        // flex-direction:
        .info {
          display: flex;
        // width: 100%;
          flex-direction: column;
        }
        .name {
          font-size: 14px;
          letter-spacing: -0.31px;
          color: #333333;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .shop-logo{
          margin-right: 6px;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .desc {
          font-size: 12px;
          letter-spacing: -0.4px;
          color: #333;
          margin-top: 3px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      .cell-time {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        width: 105px;
        .time {
          font-size: 11px;
          letter-spacing: -0.4px;
          color:rgba(51,51,51,0.5);
          margin-top: 3px;
        }
      }
    }
    .cell-extra {
      margin-top: 10px;
      .cell-curreny {
        display: flex;
        align-items: flex-end;
        position: relative;
        ::v-deep .amount {
          line-height: 26px;
          @include font-color();
          font-size: 36px;
        }
        ::v-deep .amount-type {
          @include font-color();
          font-size: 20px;
          line-height: 16px;
          letter-spacing: -0.4px;
          bottom: 1px;
        }
        .discount {
          line-height: 26px;
          font-size: 36px;
          @include font-color();
          letter-spacing: -1.05px;
        }
        .discount-type {
          font-size: 20px;
          @include font-color();
          margin-left: 2px;
          line-height: 19px;
        }
      }
    }
  }
</style>
